import * as CryptoJS from 'crypto-js';

const encryptionKey = process.env.REACT_APP_ENCRYPTION_KEY || '';

export const encryptString = (text: string) => {
  //console.log("encryptString- encryptionKey:",encryptionKey);
  return CryptoJS.AES.encrypt(text, encryptionKey).toString();
};

export const decryptString = (encryptedText: string) => {
  const bytes = CryptoJS.AES.decrypt(encryptedText, encryptionKey);
  return bytes.toString(CryptoJS.enc.Utf8);
};
